import { Outlet, NavLink } from 'react-router-dom';

export function Layout() {
    return (
        <div className="layout">
            <aside className="sidebar">
                <div className="sidebar-logo">
                    <DnaIcon />
                    HelixAI
                </div>
                <nav className="sidebar-nav">
                    <NavLink to="/" className={navClass}>
                        <IconDashboard /> Dashboard
                    </NavLink>
                    <NavLink to="/analysis" className={navClass}>
                        <IconAnalysis /> Analysis
                    </NavLink>
                    <NavLink to="/reports" className={navClass}>
                        <IconReports /> Reports
                    </NavLink>
                </nav>
            </aside>
            <main className="main-content">
                <Outlet />
            </main>
        </div>
    );
}

function navClass({ isActive }: { isActive: boolean }) {
    return `nav-link ${isActive ? 'active' : ''}`;
}

function DnaIcon() {
    return (
        <svg className="dna-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M2 15c6.667-6 13.333 0 20-6" />
            <path d="M9 22c1.798-1.998 2.518-3.995 2.807-5.993" />
            <path d="M15 2c-1.798 1.998-2.518 3.995-2.807 5.993" />
            <path d="M17 6l-2.5-2.5" />
            <path d="M14 8l-1-1" />
            <path d="M7 18l2.5 2.5" />
            <path d="M3.5 14.5l.5.5" />
            <path d="M20.5 9.5l-.5-.5" />
            <path d="M10 16l1 1" />
            <path d="M2 9c6.667 6 13.333 0 20 6" />
        </svg>
    );
}

function IconDashboard() {
    return (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="3" width="7" height="9" rx="1" />
            <rect x="14" y="3" width="7" height="5" rx="1" />
            <rect x="14" y="12" width="7" height="9" rx="1" />
            <rect x="3" y="16" width="7" height="5" rx="1" />
        </svg>
    );
}

function IconAnalysis() {
    return (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
        </svg>
    );
}

function IconReports() {
    return (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <path d="M14 2v6h6M16 13H8M16 17H8M10 9H8" />
        </svg>
    );
}
